import { storage } from 'BASE/common/util/util.storage';

export const Login = function (Token, UserName, NickName, LoginType) {
    let _expiresTime = new Date().getTime() + (Token.expires_in * 1000);
    storage.local.set(storage.keys.ACCESS_TOKEN, Token.access_token, _expiresTime);
    storage.local.set(storage.keys.ISAGENT, Token.isAgent, _expiresTime);
    storage.local.set(storage.keys.USER_NAME, UserName, _expiresTime);
    storage.local.set(storage.keys.NICK_NAME, NickName, _expiresTime);
    storage.local.set(storage.keys.EXPIRES_TIME, `${_expiresTime}`);
    storage.local.set(storage.keys.LOGIN_TYPE, LoginType);
    storage.local.set(storage.keys.BET_EVER_VERIFIED, false);
};

export const Logout = function () {
    storage.local.remove(storage.keys.ACCESS_TOKEN);
    storage.local.remove(storage.keys.ISAGENT);
    storage.local.remove(storage.keys.USER_NAME);
    storage.local.remove(storage.keys.NICK_NAME);
    storage.local.remove(storage.keys.EXPIRES_TIME);
    storage.local.remove(storage.keys.LOGIN_TYPE);
    storage.local.remove(storage.keys.CONTRACT_TYPE);
    storage.local.remove(storage.keys.DIVIDENDRECORD_STATE);
    storage.local.remove(storage.keys.DAILY_PAY_RECORD_STATE);
    storage.local.remove(storage.keys.ALLOW_PAY_DIVIDEND_OUT_OF_PLATFORM);
    storage.local.remove(storage.keys.LOGIN_POPUP); //刪除彈跳公告的暫存
    storage.local.remove(storage.keys.DAILYPAY_HINT_MESSAGE);
    storage.local.remove(storage.keys.EXTERNAL_GAME_NAMES);
    storage.local.remove(storage.keys.LOGIN_RECORD);
    storage.local.remove(storage.keys.BET_VERIFICATION);
    storage.local.remove(storage.keys.BET_EVER_VERIFIED);
    storage.local.remove(storage.keys.LOGIN_ENTRY_POP);
    storage.local.remove(storage.keys.GREETINGS);
    storage.local.remove(storage.keys.CHAT_OPENED_ROOM_INFO);
    storage.local.remove(storage.keys.BET_ANIMAL_OLYMPIC);
    if(!ENVIRONMENT.CORDOVA) {
        //不是Cordova的才刪除
        storage.local.remove(storage.keys.API_PROXY);
    }

    // 刪除全站群聊session token
    storage.session.remove(storage.keys.CHAT_SITE_GROUP_SESSION_TOKEN);
};